import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ConfiguratorPartnership } from '@models';
import { GetPartnershipParams } from './service';

export enum GetPartnershipActions {
  Failure = '[Configurator GetPartnership] Failure',
  Request = '[Configurator GetPartnership] Request',
  Success = '[Configurator GetPartnership] Success',
}

export const GetPartnershipFailure = createAction(GetPartnershipActions.Failure, props<{ error: HttpErrorResponse }>());

export const GetPartnershipRequest = createAction(
  GetPartnershipActions.Request,
  props<{ parameters: GetPartnershipParams }>()
);

export const GetPartnershipSuccess = createAction(
  GetPartnershipActions.Success,
  props<{ data: ConfiguratorPartnership }>()
);
